import { DateInputProps } from '@components/DateInput/DateInput';
import { DateInputSmallGrey } from './DateInputAssets.styles';

export const DateInputAssets = (props: DateInputProps) => {
  return <DateInputSmallGrey {...props} height={32} placeholder="Empty" />;
};
